import { DraggableAttributes, DraggableSyntheticListeners } from '@dnd-kit/core';
import { createContext } from 'react';

interface SortableContext {
    attributes: DraggableAttributes;
    listeners: DraggableSyntheticListeners;
    ref(node: HTMLElement | null): void;
}

export const SortableItemContext = createContext<SortableContext>({
    attributes: {
        role: 'list',
        tabIndex: 0,
        'aria-disabled': false,
        'aria-pressed': undefined,
        'aria-roledescription': 'List of draggable items',
        'aria-describedby': '',
    },
    listeners: undefined,
    ref() {},
});
